export default "__VITE_ASSET__Bet8KqjF__"